import { GlobalProduct } from './StockReceipt';
import User from './User';

export enum StockMovementType {
  TRANSFER = 'TRANSFER',
  ADJUSTMENT = 'ADJUSTMENT',
  LOSS = 'LOSS',
  RECEIPT = 'RECEIPT',
  SALE = 'SALE',
  PRODUCTION = 'PRODUCTION',
}
export enum StockMovementSourceType {
  WAREHOUSE = 'WAREHOUSE',
  COMMERCE = 'COMMERCE',
  EXTERNAL = 'EXTERNAL',
  PRODUCTION_CENTER = 'PRODUCTION_CENTER',
}
export enum StockMovementDestinationType {
  WAREHOUSE = 'WAREHOUSE',
  COMMERCE = 'COMMERCE',
  EXTERNAL = 'EXTERNAL',
}
export enum StockMovementReason {
  DAMAGED = 'DAMAGED',
  EXPIRED = 'EXPIRED',
  INVENTORY_COUNT = 'INVENTORY_COUNT',
  MANUAL_ADJUSTMENT = 'MANUAL_ADJUSTMENT',
}
export enum StockMovementOperation {
  INCREASE = 'INCREASE',
  DECREASE = 'DECREASE',
}

export enum StockMovementStatus {
  DRAFT = 'DRAFT',
  CONFIRMED = 'CONFIRMED',
  CANCELLED = 'CANCELLED',
}

export interface StockMovementLocation {
  id: string;
  name: string;
  type: StockMovementSourceType | StockMovementDestinationType;
}

export interface StockMovementRecipe {
  id: string;
  globalProductId: number;
  productName: string | null;
}

export interface StockMovement {
  id: string;
  venueId: string;
  type: StockMovementType;

  sourceType: StockMovementSourceType | null;
  sourceId: string | null;
  destinationType: StockMovementDestinationType;
  destinationId: string | null;
  source?: StockMovementLocation | null;
  destination?: StockMovementLocation | null;

  reason: StockMovementReason | null;

  status?: StockMovementStatus;
  createdByUserId: string;
  receivedByUserId?: string | null;
  stockReceptionId: string | null;
  orderId: string | null;
  recipeId: string | null;
  recipe?: StockMovementRecipe | null;

  createdAt: string;
  localDatetime: string;

  createdBy?: User;
  receivedBy?: User;
  items?: StockMovementItem[];
}

export interface StockMovementItem {
  id: string;
  quantity: number;
  unitCost: number;
  stockMovementId: string;
  globalProductId: number;
  averageCostSnapshot?: number | null;
  replacementCostSnapshot?: number | null;
  operation?: StockMovementOperation | null;
  warehouseId?: string | null;
  globalProduct?: Pick<
    GlobalProduct,
    'id' | 'name' | 'sku' | 'unitMeasure' | 'receptionUnitMeasure' | 'unitsPerReceptionUnit'
  > | null;
  createdAt: string;
}
export interface WarehouseProductStock {
  id: number;
  name: string;
  productId: string;
  sku: string | null;
  stock: number;
}

// Editable row inside the form's products table
export interface MovementProductRow {
  id: string;
  quantity: number;
}

// Values managed by Formik inside the form
export interface MovementFormValues {
  venueId: string;
  originWarehouseId: string;
  destinationWarehouseId: string;
  products: { id: string; quantity: string | number }[];
}

// Payload sent to the backend (create / update)
export interface StockMovementPayload {
  venueId: string;
  originWarehouseId: string;
  destinationWarehouseId: string;
  products: { id: string; quantity: string | number }[];
}

//
export interface StockRecipe {
  id: string;
  globalProductId: number | string;
  items?: StockRecipeItem[];
  globalProduct?: GlobalProduct;
}

export interface StockRecipeItem {
  id: string;
  ingredientGlobalProductId: number;
  quantity: number;
  ingredient?: GlobalProduct;
}
